import styles from './ContentBox.module.css';

interface ContentBoxProps extends React.HTMLAttributes<HTMLDivElement> {}

const ContentBox = ({ className, ...props }: ContentBoxProps): React.JSX.Element => (
    <div className={`${styles.contentBox}${className ? ` ${className}` : ''}`} {...props} />
);

export { ContentBox };
